import { getSkillDisplayName } from '#pplx/frontend/apps/ask/skill-cards/skillDisplay.js';
import { isControlLocalBrowserSkillName } from '#pplx/frontend/apps/ask/skills/utils/controlLocalBrowserSkill.js';
import { getMenuIcon } from '#pplx/frontend/apps/ask/skills/utils/getMenuIcon.js';
import { getSkillMentionURL } from '#pplx/frontend/apps/ask/skills/utils/getSkillMentionURL.js';
import { isDeepResearchSkillName } from '#pplx/frontend/ask-models/deepResearchSkill.js';
export function getComposerSkillMention({ skill, intl, prefixWithSlash, }) {
    const localizedName = resolveLocalizedSkillName({ skill, intl });
    return {
        id: skill.id,
        kind: 'skill',
        text: skill.name,
        ...(localizedName === undefined ? {} : { localizedName }),
        url: getSkillMentionURL(skill),
        icon: { type: 'icon', icon: getMenuIcon(skill.name) },
        ...(prefixWithSlash === undefined ? {} : { prefixWithSlash }),
    };
}
/**
 * Keeps first-party translations aligned across legacy Lexical and Composer.
 *
 * @returns The translated first-party display name, or a display-name override that
 * differs from the canonical `skill.name`. Returns `undefined` when there is no
 * localized override, so the mention displays `skill.name` and omits `localizedName`
 * from its payload.
 */
export function resolveLocalizedSkillName({ skill, intl, }) {
    if (isDeepResearchSkillName(skill.name)) {
        return intl.formatMessage({
            defaultMessage: 'Deep Research',
            description: 'Branded display name for the Deep Research skill',
            id: 'a1a097df67',
        });
    }
    if (isControlLocalBrowserSkillName(skill.name)) {
        return intl.formatMessage({
            defaultMessage: 'Control Browser',
            description: 'Branded display name for the control-browser skill',
            id: '48c0a99e4f',
        });
    }
    if (skill.name === 'computer-learn') {
        return intl.formatMessage({
            defaultMessage: 'Learn Step by Step',
            id: '73cf8e7170',
            description: 'Branded display name for the Computer Learn skill',
        });
    }
    const displayName = getSkillDisplayName(skill);
    return displayName === skill.name ? undefined : displayName;
}
//# sourceMappingURL=getComposerSkillMention.js.map